import { useForgotPassword } from "@/services/queries/useAuth";
import { useResetPasswordProps } from "../forgot-password.types";

export function useResetPassword({ successCallback }: useResetPasswordProps) {
  const { mutateAsync: resetPassword, isPending, isSuccess } = useForgotPassword({ successCallback })

  const onLoginSubmit = async (data: { email: string }) => {
    await resetPassword({ login: data.email })
  }

  return {
    onLoginSubmit,
    isPending,
    isSuccess
  }
}